import React from "react"
import Moment from "moment"
import Currency from "components/common/Currency"
import { AuthorizedSummaryToolbar } from "components/authentication/controls/AuthorizedControls"

const Toolbar = AuthorizedSummaryToolbar(p => p.canWriteChargeRates)

const CostRateRow = (
    {
        classification,
        effectiveDate,
        rate,
        disabled
    }) => (
        <tr>
            <td>{classification.name}</td>
            <td>{Moment(effectiveDate).format("DD/MM/YYYY")}</td>
            <td>{Currency(rate)}</td>
            <td><Toolbar disabled={disabled} /></td>
        </tr>
    )



export default CostRateRow 